var path = 'areas/shared/views/export_entity_dialog.html';
var html = "<div class=modal-header> <button class=close type=button data-dismiss=modal aria-hidden=true ng-click=close()>×</button> <h3>Export</h3> </div> <div class=modal-body> <div id=scriptEditor ui-ace=\"{onLoad: editorLoaded}\" ng-model=entityJson></div> <p class=tutorial>Copy the entire contents of the editor to share this template with other Octopus Deploy servers.</p> </div> <div class=modal-footer> <button class=\"btn btn-default\" ng-click=close()>Close</button> </div> ";
window.angular.module('ng').run(['$templateCache', function(c) { c.put(path, html) }]);
module.exports = path;


//////////////////
// WEBPACK FOOTER
// ./app/areas/shared/views/export_entity_dialog.html
// module id = 7468163898291282
// module chunks = 1